var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-layout-forms" },
    [
      _c(
        "div",
        { staticClass: "page-layout-forms__header" },
        [_vm._t("header")],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-layout-forms__content" },
        [
          _c("LayoutContent3Cols", {
            scopedSlots: _vm._u(
              [
                {
                  key: "sidebar-left",
                  fn: function() {
                    return [_vm._t("sidebar-left")]
                  },
                  proxy: true
                },
                {
                  key: "content",
                  fn: function() {
                    return [_vm._t("content")]
                  },
                  proxy: true
                },
                {
                  key: "sidebar-right",
                  fn: function() {
                    return [_vm._t("sidebar-right")]
                  },
                  proxy: true
                }
              ],
              null,
              true
            )
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm._t("footer")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }